import React from 'react'
System.import('./index.scss')
import Content from '../../../components/content'
import Editable from '../../../components/editable'
import { Row, Col } from '../../../components/layout'

const News = (props) => {
  const idPrefix = 'news'
  //
  return [{
    uid: idPrefix + '-1',
    html:(
      <div className="section-news">
        <div className="container">
          <Content { ...props.title } className="text-center" />
          <Row className="section-list-items">
            {props.list.items.map((item, index) =>
              <Col key={index} className="section-list-item col-sm-6" name={ item.title.content }>
                <Editable { ...item.title }>
                  <h4><a href={item.button.url} className="news-title">{item.title.content}</a></h4>
                </Editable>
                <Content { ...item.description } />
                <Content { ...item.button } className="btn-link"/>
              </Col>
            )}
          </Row>
        </div>
      </div>
    )
  }]
}

export default News


// WEBPACK FOOTER //
// ./app/javascript/app/site/structures/section/news/index.js